import React from 'react'
import { styled } from '@mui/material/styles'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import { CardMedia } from '@mui/material/'
import { CarouselDots } from '@components/organisms/CarouselDots'

const PREFIX = 'ImageCarousel'

const classes = {
  buttonContainer: `${PREFIX}-buttonContainer`,
  buttonBack: `${PREFIX}-buttonBack`,
  buttonNext: `${PREFIX}-buttonNext`,
  dot: `${PREFIX}-dot`,
  media: `${PREFIX}-media`,
}

const StyledCarouselProvider = styled(CarouselProvider)(({ theme }) => ({
  [`& .${classes.buttonContainer}`]: {
    position: 'relative',
  },

  [`& .${classes.buttonBack}`]: {
    backgroundColor: 'rgba( 255, 255, 255, 0.75 )',
    border: 'none',
    color: 'black',
    fontSize: '30px',
    left: 0,
    paddingBottom: '6px',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '35px',
  },

  [`& .${classes.buttonNext}`]: {
    backgroundColor: 'rgba( 255, 255, 255, 0.75 )',
    border: 'none',
    color: 'black',
    fontSize: '30px',
    paddingBottom: '6px',
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '35px',
  },

  [`& .${classes.dot}`]: {
    backgroundColor: 'white',
  },

  [`& .${classes.media}`]: {
    height: 'auto',
    objectFit: 'scale-down',
    padding: theme.spacing(1),
    width: '100%',
  },
}))

type Props = {
  thumbnails: { url: string }[] | undefined
}

export const ImageCarousel = (props: Props) => (
  <StyledCarouselProvider
    infinite={true}
    naturalSlideWidth={340}
    naturalSlideHeight={470}
    visibleSlides={1}
    totalSlides={props.thumbnails?.length ?? 0}
  >
    <div className={classes.buttonContainer}>
      <Slider>
        {props.thumbnails?.map((thumbnail, index: number) => (
          <Slide key={index} index={index}>
            <CardMedia className={classes.media} component="img" image={thumbnail.url} />
          </Slide>
        ))}
      </Slider>
      <ButtonBack className={classes.buttonBack}>&#8249;</ButtonBack>
      <ButtonNext className={classes.buttonNext}>&#8250;</ButtonNext>
    </div>
    <CarouselDots totalSlides={props.thumbnails?.length ?? 0} />
  </StyledCarouselProvider>
)
